import SEO from '@/components/feature/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import BrandSection from './components/BrandSection';
import HotComicsSection from './components/HotComicsSection';
import LatestUpdatesSection from './components/LatestUpdatesSection';
import CategoryGridSection from './components/CategoryGridSection';
import TestimonialsSection from './components/TestimonialsSection';
import { comics } from '@/mocks/comics';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': 'http://gxzzmm66.cn/#website',
  url: 'http://gxzzmm66.cn/',
  name: '韩漫网',
  description: '韩漫网 - 免费韩漫在线阅读平台，提供最新最全的韩国漫画资源',
  inLanguage: 'zh-CN',
  publisher: {
    '@type': 'Organization',
    '@id': 'http://gxzzmm66.cn/#organization',
    name: '韩漫网',
    url: 'http://gxzzmm66.cn/',
    description: '国内领先的免费韩漫在线阅读平台',
    foundingDate: '2019',
  },
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'http://gxzzmm66.cn/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: '首页',
      item: 'http://gxzzmm66.cn/',
    },
  ],
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '韩漫网上的漫画都是免费的吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '是的！韩漫网上的所有漫画资源均完全免费，无需付费即可畅享高清流畅的在线阅读体验。',
      },
    },
    {
      '@type': 'Question',
      name: '韩漫网的漫画更新速度快吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们每日与韩国同步更新最新章节，确保您能第一时间阅读到最新内容，热门作品通常在发布后数小时内即可在韩漫网阅读。',
      },
    },
    {
      '@type': 'Question',
      name: '韩漫网支持哪些设备阅读？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '韩漫网采用响应式设计，完美支持电脑、平板和手机等各类设备，您可以在任何设备上享受流畅的漫画阅读体验。',
      },
    },
    {
      '@type': 'Question',
      name: '韩漫网有多少部漫画可以阅读？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '韩漫网目前收录超过15000部韩国漫画，涵盖恋爱、奇幻、动作、悬疑、搞笑、历史古风等多种类型，并且资源持续扩充中。',
      },
    },
    {
      '@type': 'Question',
      name: '如何在韩漫网找到想看的漫画？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以通过首页的分类浏览功能按类型筛选漫画，也可以使用搜索功能直接查找您想看的作品。热门推荐和最新更新列表也能帮助您发现精彩内容。',
      },
    },
  ],
};

export default function Home() {
  const itemListSchema = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: comics.slice(0, 8).map((comic, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@type': 'Book',
        name: comic.title,
        author: {
          '@type': 'Person',
          name: comic.author,
        },
        description: comic.description,
        url: `http://gxzzmm66.cn/comic/${comic.id}`,
      },
    })),
  };

  return (
    <>
      <SEO
        schemaData={{
          ...homeSchema,
          ...breadcrumbSchema,
          ...itemListSchema,
          ...faqSchema,
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <BrandSection />
        <HotComicsSection />
        <LatestUpdatesSection />
        <CategoryGridSection />
        <TestimonialsSection />
      </main>
      <Footer />
    </>
  );
}